import textarea from "@/components/Common/CustomTextarea/CustomTextarea.vue";

const customTextarea = {
  install: function (Vue) {
    Vue.component('customTextarea', textarea);
  }
}
export default customTextarea;